module.exports = __webpack_public_path__ + "img/i-outside.093e91da.svg";